<template>
  <div>
    <div class="header">
      <div class="dialog-title" v-if="activeName === 'picture'">
        <span
          @click="togglesGalleryTypes('myGallery')"
          class="title-one title"
          :class="{ 'my-gallery': galleryActive === 'myGallery' }"
          >我的图库</span
        >
        <span
          v-if="!hideCommonGallery"
          @click="togglesGalleryTypes('commonGallery')"
          class="title-two title"
          :class="{ 'my-gallery': galleryActive === 'commonGallery' }"
          >公共图库</span
        >
      </div>
      <div class="dialog-title" v-else>
        <span @click="togglesGalleryTypes('myGallery')" class="title my-gallery">我的音视频</span>
      </div>
    </div>
    <div class="gallery-wrapper" v-if="galleryActive === 'myGallery' && activeName === 'picture'">
      <div class="gallery-category">
        <div class="category-tree category-tree-myGallery">
          <el-scrollbar
            style="height: 100%"
            wrapStyle="overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;"
          >
            <el-tree
              ref="treePic"
              empty-text=""
              :data="pictureDirList"
              :props="{ children: '_child', label: 'name' }"
              node-key="id"
              :default-expanded-keys="defaultExpandedkeys"
              :indent="10"
              highlight-current
              key="treePic"
              @node-click="clickPictureDir"
            >
              <span slot-scope="{ node, data }" class="custom-tree-node">
                <span :title="data.name" class="tree-item-node-name" :class="{ 'tree-node-child': data.level > 0 }">
                  <span class="tree-item-name">
                    <span v-if="data.type === 'group'" class="qm-icon qm-icon-group"></span>
                    <span v-else-if="data.type === 'brand'" class="qm-icon qm-icon-brand"></span>
                    <span v-else class="qm-icon qm-icon-folder2"></span>
                    <span>{{ data.name }}</span>
                  </span>
                  <span class="image-num">{{ data.count }}</span>
                </span>
                <span class="more-operations" :class="{ 'is-show-add': data.type == 'group' || data.type == 'brand' }">
                  <span>
                    <el-dropdown
                      @command="handleCommand"
                      trigger="hover"
                      v-if="data.type !== 'group' && data.type !== 'brand'"
                    >
                      <i class="el-icon-more delete-edit-operations"></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{ type: 'delete', node: node }">删除</el-dropdown-item>
                        <el-dropdown-item :command="{ type: 'rechristen', node: node }">重命名</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                  <span>
                    <el-dropdown @command="handleCommand" trigger="hover" v-if="data.level < 2">
                      <i class="el-icon-plus add-operations"></i>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item :command="{ type: 'add', node: node }">新建</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </span>
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="gallery-main">
        <div class="pictureNew-tit">
          <!-- 添加图片搜索功能 -->
          <div class="searchImg">
            <el-input
              class="search-img"
              clearable
              placeholder="请输入图片名称"
              prefix-icon="el-icon-search"
              v-model="imageName"
              @input="searchImagesResult(1)"
              @keyup.enter.native="searchImages(1)"
              @clear="emptySearchResults(1)"
            ></el-input>
          </div>
          <div class="pictureNew-category-add">
            <el-upload
              class="upload-btn"
              ref="uploadPicture"
              :headers="uploadHeader"
              :action="uploadImgUrl"
              :data="uploadParam"
              name="upfile"
              multiple
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :on-success="onSuccess"
              :on-error="onError"
              :disabled="loadingUpload"
              with-credentials
              :http-request="uploadImage"
            >
              <el-button class="qm-button">
                <template v-if="!loadingUpload"> <i class="qm-icon-upload"></i>上传图片 </template>
                <template v-else> <i class="qm-icon-upload"></i>上传中... </template>
              </el-button>
            </el-upload>
            <el-select v-model="batchPeration" placeholder="批量操作" class="batch-perationData">
              <el-option v-for="item in batchPerationData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="image-wrapper">
          <div class="image-list-main">
            <div class="image-list-item">
              <div class="image-operation-panel">
                <div class="select-images-num" v-if="batchPeration">
                  <el-checkbox size="mini" class="checkAll" v-model="checkAll" :indeterminate="isIndeterminate">
                    全选
                    <span v-if="selectImages.length > 0"
                      >已选中
                      <span class="image-operation-panel_num">{{ selectImages.length }}</span>
                      张</span
                    >
                  </el-checkbox>
                  <el-button
                    v-if="batchPeration == 1"
                    class="delete-picture"
                    type="text"
                    size="mini"
                    :disabled="!selectImages.length"
                    @click="deleteSelectImages"
                    >删除</el-button
                  >
                  <el-popover v-model="moveTreevisible" placement="right" width="300" trigger="click">
                    <el-tree
                      ref="treeMovePic"
                      empty-text=""
                      :data="pictureDirList"
                      :props="{ children: '_child', label: 'name' }"
                      node-key="id"
                      :default-expanded-keys="[0]"
                      :expand-on-click-node="false"
                      :indent="10"
                      highlight-current
                      @node-click="moveImagesToTree"
                    >
                      <span slot-scope="{ node, data }" class="custom-tree-node">
                        <span
                          :title="data.name"
                          class="tree-item-node-name"
                          :class="{ 'tree-node-child': data.id != 0 }"
                          >{{ data.name }}</span
                        >
                      </span>
                    </el-tree>
                    <el-button
                      :disabled="!selectImages.length"
                      slot="reference"
                      v-show="batchPeration == 2"
                      class="delete-picture"
                      type="text"
                      size="mini"
                      >移动
                    </el-button>
                  </el-popover>
                  <el-button class="cancel-delete-picture" type="text" size="mini" @click="cancelBatchOperations"
                    >取消</el-button
                  >
                </div>
                <span v-else
                  >已选中<span class="image-operation-panel_num">{{ selectImages.length }}</span
                  >张</span
                >
              </div>
              <el-scrollbar
                style="height: calc(100% - 36px)"
                wrapStyle="overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;"
                v-loading="imageListLoading"
              >
                <div class="image-list">
                  <div
                    class="image-item"
                    :class="{ active: checkboxStatus(item.id) }"
                    v-for="(item, index) in imagesList"
                    :key="`image+${index}`"
                    @click="viewImageDetail(item)"
                  >
                    <div v-if="item.uploadState == 'upload'" class="image-upload-loading">
                      <div class="text"><i class="el-icon-loading"></i>上传中...</div>
                      <el-button type="text" size="small" @click="abort">取消上传</el-button>
                    </div>
                    <div
                      v-else-if="item.uploadState == 'success'"
                      class="image-item-main"
                      :class="{
                        'batch-peration-show-btn': !batchPeration,
                        'image-item-main-new': item.latestUpload,
                      }"
                      @click="imageCheckboxChange(item)"
                    >
                      <img draggable="false" class="image" :src="item.domain + '/' + item.path" />
                      <div class="image-title-bg image-title-show">
                        <span class="image-name">
                          {{ item.name }}
                        </span>
                      </div>
                      <div class="image-title-bg image-download-magnify-delete">
                        <i class="qm-icon-enlarge" @click.stop="magnifyThePicture(item)"></i>
                        <span>
                          <i
                            v-if="isShowClippingBtn(item.name)"
                            class="qm-icon-crop"
                            @click.stop="shearPictures(item)"
                          ></i>
                          <i class="qm-icon-download" @click.stop="downloadPic(item)"></i>
                          <i class="qm-icon-delete" @click.stop="deletePicture(item)"></i>
                        </span>
                      </div>
                      <span class="state-check" v-if="checkboxStatus(item.id)">
                        <i class="el-icon-check"></i>
                      </span>
                    </div>
                    <div v-else-if="item.uploadState == 'error'" class="image-upload-loading">
                      <div class="text">上传失败</div>
                      <el-button type="text" size="small" @click="delUploadError(index)">删除</el-button>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div class="image-operation-page">
              <el-pagination
                @size-change="handleSizeChange"
                @current-change="paginationChange"
                :current-page.sync="currentPage"
                :page-sizes="customPageSizes"
                :page-size="pageSize"
                layout="prev, pager, next,sizes"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
          <div class="image-detail-wrapper">
            <!-- 图库信息展示 -->
            <pictorial-information
              :imageInfo="imageInfo"
              :isShowMoreImage="isShowMoreImage"
              :selectImages="selectImages"
              :galleryType="1"
              :galleryShowType="1"
              @saveImageInfo="saveImageInfo"
            ></pictorial-information>
            <div class="gallery-control-wrapper" v-if="showInsertBtn && !batchPeration">
              <el-button type="primary" :disabled="!selectImages.length" @click="submitSelectImages">插入</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="gallery-wrapper" v-if="galleryActive === 'commonGallery' && activeName === 'picture'">
      <div class="gallery-category">
        <div class="category-tree">
          <el-scrollbar
            style="height: 100%"
            wrapStyle="overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;"
          >
            <el-tree
              ref="treeCommonPic"
              empty-text=""
              :data="pictureCommonDirList"
              :props="{ children: '_child', label: 'name' }"
              node-key="id"
              :default-expanded-keys="[0]"
              :expand-on-click-node="false"
              :indent="10"
              highlight-current
              key="treeCommonPic"
              @node-click="clickCommonPictureDir"
            >
              <span slot-scope="{ node, data }" class="custom-tree-node">
                <span :title="data.name" class="tree-item-node-name" :class="{ 'tree-node-child': data.level > 0 }">
                  <span class="tree-item-name">
                    <span v-if="data.type === 'group'" class="qm-icon qm-icon-group"></span>
                    <span v-else-if="data.type === 'brand'" class="qm-icon qm-icon-brand"></span>
                    <span v-else class="qm-icon qm-icon-folder2"></span>
                    <span>{{ data.name }}</span>
                  </span>
                  <span class="image-num">{{ data.count }}</span>
                </span>
              </span>
            </el-tree>
          </el-scrollbar>
        </div>
      </div>
      <div class="gallery-main">
        <div class="pictureNew-tit">
          <div class="searchImg">
            <el-input
              class="search-img"
              clearable
              placeholder="请输入图片名称"
              prefix-icon="el-icon-search"
              v-model="imageName"
              @input="searchImagesResult(2)"
              @keyup.enter.native="searchImages(2)"
              @clear="emptySearchResults(2)"
            ></el-input>
          </div>
        </div>
        <div class="image-wrapper">
          <div class="image-list-main">
            <div class="image-list-item">
              <div class="image-operation-panel">
                <span
                  >已选中<span class="image-operation-panel_num">{{ selectImages.length }}</span
                  >张</span
                >
              </div>
              <el-scrollbar
                style="height: calc(100% - 36px)"
                wrapStyle="overflow-x:hidden;padding-left: 10px;padding-right: 10px;padding-top: 10px;"
                v-loading="imageListLoading"
              >
                <div class="image-list">
                  <div
                    class="image-item"
                    :class="{ active: checkboxStatus(item.id) }"
                    v-for="(item, index) in imagesCommonList"
                    :key="`image+${index}`"
                    @click="viewImageDetail(item)"
                  >
                    <div class="image-item-main batch-peration-show-btn" @click="imageCheckboxChange(item)">
                      <img draggable="false" class="image" :src="item.domain + '/' + item.path" />
                      <div class="image-title-bg image-title-show">
                        <span class="image-name">
                          {{ item.name }}
                        </span>
                      </div>
                      <div class="image-title-bg image-download-magnify-delete magnify-common">
                        <i class="qm-icon-enlarge" @click.stop="magnifyThePicture(item)"></i>
                      </div>
                      <span class="state-check" v-if="checkboxStatus(item.id)">
                        <i class="el-icon-check"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
            </div>
            <div class="image-operation-page">
              <el-pagination
                @size-change="handleCommonSizeChange"
                @current-change="paginationCommonChange"
                :current-page.sync="currentPage"
                :page-sizes="customPageSizes"
                :page-size="pageSize"
                layout="prev, pager, next,sizes"
                :total="total"
              >
              </el-pagination>
            </div>
          </div>
          <div class="image-detail-wrapper">
            <!-- 图库信息展示 -->
            <pictorial-information
              :imageInfo="imageInfo"
              :isShowMoreImage="isShowMoreImage"
              :selectImages="selectImages"
              :galleryType="0"
              :galleryShowType="1"
            ></pictorial-information>
            <div class="gallery-control-wrapper" v-if="showInsertBtn && !batchPeration">
              <el-button type="primary" :disabled="!selectImages.length" @click="submitSelectImages">插入</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="activeName === 'video'">
      <VideoTutorials
        :visible="visible"
        :multiple="multiple"
        :multipleLimit="multipleLimit"
        :sizeLimit="sizeLimit"
        :mediaTypes="mediaTypes"
        @changeSelectVideo="changeSelectVideo"
      />
    </div>

    <!-- 图库放大 -->
    <el-dialog
      :append-to-body="true"
      title=""
      :visible.sync="dialogImgVisible"
      custom-class="qm-picture-library-enlarge-dialog"
    >
      <div class="pics">
        <img draggable="false" :src="dialogImg" alt="" />
      </div>
    </el-dialog>
    <deltree-pop ref="deltreePop" :delType="1" @delTargetItem="delCategory"></deltree-pop>
    <image-clipping-popover
      :image-clipping-visible.sync="imageClippingVisible"
      :image-clipping-info="imageClippingInfo"
      :category-id="currentDir.category_id"
      :store-id="storeId"
      @imageCroppingSuccess="imageCroppingSuccess"
    ></image-clipping-popover>
  </div>
</template>

<script>
import * as api from './api'
import { parseTime, stripscript, debounce } from './utils'
import PictorialInformation from './components/pictorial-information'
import DeltreePop from './components/deltree-pop'
import VideoTutorials from './components/video-tutorials'
import ImageClippingPopover from './components/imageClippingPopover.vue'

export default {
  name: 'QmPictureLibrary',
  props: {
    activeName: {
      type: String,
      default: 'picture',
    },
    // 是否显示
    visible: {
      type: Boolean,
      default: false,
    },
    // 是否多选
    multiple: {
      type: Boolean,
      default: false,
    },
    // 多选时候的数量 0 不限制 只有在multiple 为true的时候生效
    multipleLimit: {
      type: [Number, String],
      default: 0,
    },

    // 限制图片的大小 0 限制 单位KB
    sizeLimit: {
      type: [Number, String],
      default: 0,
    },

    // 每次调用弹窗的标识符，当前弹窗的类型，处理一个页面多个地方获取组件图片
    imagesType: {
      type: String,
      default: 'img',
    },

    // 为了解决遮罩层会在最上面 在嵌套Dialog场景中，将内层 Dialog 的该属性设置为 true，它就会插入至 body 元素上，从而保证内外层 Dialog 和遮罩层级关系的正确
    appendToBody: {
      type: Boolean,
      default: false,
    },
    // 允许选择的媒体类型
    mediaTypes: {
      type: [Array, String],
      default: () => ['video'],
    },
    // 是否不显示公共图库
    hideCommonGallery: {
      type: Boolean,
      default: false,
    },
    // 自定义每页显示个数选择器的选项设置
    customPageSizes: {
      type: Array,
      default: () => [20, 40, 60],
    },
    showInsertBtn: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      galleryActive: 'myGallery',
      loadingUpload: false, // 图片上传Loading
      uploadImgUrl: '/coroutine/picture/file/upload', // 图片上传地址
      uploadHeader: {
        'QM-STORE-AUTH': undefined,
        'X-CSRF-TOKEN': '{{csrf_token()}}',
      },
      uploadParam: {
        category_id: 0, // 当前相册所在的分类ID
      },
      imagesList: [], // 图片的数组
      imageInfo: null, // 查看图片详情数据
      currentPage: 1, // 图片当前页数
      pageSize: 0, // 图片每页的数量
      total: 0, // 总图片数
      selectImages: [], // 选中的图片数组
      imageListLoading: false, // 获取图片列表loading
      currentDir: {
        // 当前目录
        id: 0,
        name: '',
        pid: 0,
        level: 0,
        store_id: 0,
      },
      pictureDirMax: 30,
      currentDirData: {
        _child: [],
        level: 1,
      }, // 当前点击目录的节点信息
      isIndeterminate: false, // 选中部分
      checkAll: false, // 全选
      pictureDirList: [], // 图片分组列表
      imageName: '', // 搜索关键字
      dialogImgVisible: false, // 图库放大
      dialogImg: '', // 图片路径
      batchPerationData: [
        {
          label: '批量删除',
          value: 1,
        },
        {
          label: '批量移动',
          value: 2,
        },
      ],
      batchPeration: '', // 当前选中的批量操作
      pictureCommonDirList: [], //  公共图库分类列表
      currentCommonId: 0, // 当前目录id
      imageCommonListLoading: false, // 获取图片列表loading
      imagesCommonList: [], // 公共图库当前分类图片列表
      moveTreevisible: false, // 移动
      defaultExpandedkeys: [0], // 默认展开节点信息
      currentOperatingNode: {}, // 当前操作的节点
      uploadedPicturesNumber: 0, // 上传图片数量
      imageClippingVisible: false, // 裁剪图片弹窗
      imageClippingInfo: null, // 需要裁剪图片信息
    }
  },
  components: {
    PictorialInformation,
    DeltreePop,
    VideoTutorials,
    ImageClippingPopover,
  },
  mounted() {
    window.addEventListener('click', this.deselectUpload)
  },
  beforeDestroy() {
    // 实例销毁之前对点击事件进行解绑
    window.removeEventListener('click', this.deselectUpload)
  },
  watch: {
    visible: {
      handler(n) {
        if (n && this.activeName === 'picture') {
          this.currentDir = { id: 0, name: '', pid: 0, level: 0, store_id: 0 }
          this.selectImages = []
          this.pageSize = this.defaultPageSize
          this.imageInfo = null
          this.getPictureDir(0)
          this.getImagesList(this.currentDir.id)
        }
      },
      immediate: true,
    },
    checkAll: function (val) {
      this.isIndeterminate = false
      if (val) {
        const picture = JSON.parse(JSON.stringify(this.imagesList))
        this.selectImages = picture
      } else {
        this.selectImages = []
      }
    },
  },
  computed: {
    storeId() {
      return (this.currentOperatingNode.data && this.currentOperatingNode.data.store_id) || this.currentDir.store_id
    },
    defaultPageSize() {
      return this.customPageSizes[0]
    },
    checkboxStatus() {
      return function (id) {
        return this.selectImages.some(item => item.id === id)
      }
    },
    // true显示选中的多张图片 false是显示单张图片信息
    isShowMoreImage() {
      if (this.batchPeration) {
        return false
      } else {
        if (this.selectImages && this.selectImages.length > 1) {
          return true
        } else {
          return false
        }
      }
    },
    // 是否显示裁剪按钮
    isShowClippingBtn() {
      return function (name) {
        const pictureType = name && name.split('.')[1] && name.split('.')[1].toLowerCase()
        return pictureType !== 'gif'
      }
    },
  },
  methods: {
    uploadImage: api.uploadImage,
    // 图库切换
    togglesGalleryTypes(type) {
      this.galleryActive = type
      this.imageInfo = null
      this.imageName = ''
      this.currentPage = 1
      this.selectImages = []
      if (type === 'commonGallery') {
        this.getPictureCommonDir()
        this.getCommonImagesList(0)
      } else {
        this.currentDir = { id: 0, name: '', pid: 0, level: 0, store_id: 0 }
        this.getPictureDir(0)
        this.getImagesList(this.currentDir.id)
      }
    },
    // 加载目录
    getPictureDir(currentKey) {
      try {
        this.loading = true
        this.pictureCheck = []

        api.getAlbumCategory().then(res => {
          // v3 接口
          if (Array.isArray(res.data)) {
            this.pictureDirList = res.data.map((v, i) => {
              return {
                count: v.count,
                // 需要保证tree中各节点有唯一key
                id: 0 + 'brand' + i,
                name: v.name || v.store_name || '根目录',
                pid: 0,
                level: 0,
                _child: v.cate,
                type: v.store_id == 0 ? 'group' : 'brand',
                store_id: v.store_id,
              }
            })
          } else {
            const { cate, count } = res.data
            const child = cate || []
            if (res.status) {
              this.pictureDirList = [
                {
                  count,
                  id: 0,
                  name: res.data.store_name || '根目录',
                  pid: 0,
                  level: 0,
                  _child: child,
                  type: 'brand',
                  store_id: 0,
                },
              ]
            }
          }
          this.$nextTick(() => {
            this.$refs.treePic && this.$refs.treePic.setCurrentKey(currentKey) // 设置当前选中节点为根目录
            this.currentDirData = this.$refs.treePic && this.$refs.treePic.getCurrentNode() // 获取当前选中节点信息
          })
          this.loading = false
        })
      } catch (e) {
        this.loading = false
      }
    },
    // 获取公共图库分类列表
    getPictureCommonDir() {
      try {
        this.loading = true
        this.pictureCheck = []
        api.getCommonAlbumCategory().then(res => {
          const { cate, count } = res.data
          if (res.status) {
            this.pictureCommonDirList = [
              {
                count,
                id: 0,
                name: '根目录',
                pid: 0,
                level: 0,
                _child: cate,
              },
            ]
          }
          this.$nextTick(() => {
            this.$refs.treeCommonPic && this.$refs.treeCommonPic.setCurrentKey(0) // 设置当前选中节点为根目录
          })
          this.loading = false
        })
      } catch (e) {
        this.$message.error(e.message)
        this.loading = false
      }
    },
    // 获取图片列表
    getImagesList(id) {
      let data = {
        page: this.currentPage,
        category_id: parseInt(id),
        page_size: this.pageSize,
        store_id: this.storeId,
      }
      if (this.imageName) {
        data.keywords = this.imageName
      }
      this.imageListLoading = true
      api.getPictureList(data).then(res => {
        if (res.status) {
          this.total = res.data.total_count
          this.imagesList = res.data.items.map((item, index) => {
            return {
              latestUpload: this.uploadedPicturesNumber > index,
              id: item.id,
              name: item.name,
              domain: item.save_domain,
              path: item.image_path,
              size: item.size,
              createTime: parseTime(item.created_at),
              updateTime: parseTime(item.updated_at),
              description: item.description,
              uploadState: 'success',
            }
          })
        }
        this.imageListLoading = false
      })
    },
    // 获取公共图片列表
    getCommonImagesList(id) {
      let data = {
        page: this.currentPage,
        category_id: id,
        page_size: this.pageSize,
      }
      if (this.imageName) {
        data.keywords = this.imageName
      }
      this.imageCommonListLoading = true
      api.getCommonPictureList(data).then(res => {
        if (res.status) {
          this.total = res.data.total_count
          this.imagesCommonList = res.data.items.map(item => {
            return {
              id: item.id,
              name: item.name,
              domain: item.save_domain,
              path: item.image_path,
              size: item.size,
              createTime: parseTime(item.created_at) || '',
              updateTime: parseTime(item.updated_at) || '',
              description: item.description,
            }
          })
        }
        this.imageCommonListLoading = false
      })
    },
    // 图片页面切换
    paginationChange(currentPage) {
      this.currentPage = currentPage
      this.getImagesList(this.currentDir.id)
    },
    // 图片页面切换
    paginationCommonChange(currentPage) {
      this.currentPage = currentPage
      this.getCommonImagesList(this.currentCommonId)
    },
    // 图片页面条数改变
    handleSizeChange(val) {
      this.pageSize = val
      this.getImagesList(this.currentDir.id)
    },
    // 公共图库页面条数改变
    handleCommonSizeChange(val) {
      this.pageSize = val
      this.getCommonImagesList(this.currentCommonId)
    },
    // 查看图片详情
    viewImageDetail(imageInfo) {
      const { selectImages, imagesList, imagesCommonList, galleryActive } = this
      if (selectImages && selectImages.length === 0) {
        this.imageInfo = null
        return
      } else if (selectImages.length === 1) {
        const list = galleryActive === 'myGallery' ? imagesList : imagesCommonList
        imageInfo = list.find(d => d.id === selectImages[0].id)
      }
      if (imageInfo) {
        let image = new Image()
        image.src = imageInfo.domain + '/' + imageInfo.path
        image.onload = res => {
          this.imageInfo = {
            id: imageInfo.id,
            path: imageInfo.domain + '/' + imageInfo.path,
            nameType: imageInfo.name && imageInfo.name.split('.')[1],
            partName: imageInfo.name && imageInfo.name.split('.')[0],
            name: imageInfo.name,
            size: imageInfo.size,
            width: image.width,
            height: image.height,
            createTime: imageInfo.createTime,
            updateTime: imageInfo.updateTime,
            description: imageInfo.description,
            isShowPictureName: false, // 编辑图片
            isShowDescription: false, // 编辑备注
          }
        }
      }
    },

    // 图片的checkbox切换选中状态
    imageCheckboxChange(imageInfo) {
      let selectImage = {
        ...imageInfo,
        fullPath: `${imageInfo.domain}/${imageInfo.path}`,
      }
      if (this.batchPeration) {
        let selectStatus = this._getCurrnetImageIsSelect(selectImage.id)
        if (selectStatus) {
          // 选中了则取消选中
          let index = this.selectImages.findIndex(item => item.id === selectImage.id)
          if (index > -1) {
            this.selectImages.splice(index, 1)
          }
        } else {
          // 选中图片前置判断
          let imageStatus = this._interceptSelectImage(imageInfo)
          if (imageStatus) {
            this.selectImages.push(selectImage)
          }
        }
      } else {
        let selectStatus = this._getCurrnetImageIsSelect(selectImage.id)
        if (this.multiple) {
          // 多选状态
          if (selectStatus) {
            // 选中了则取消选中
            let index = this.selectImages.findIndex(item => item.id === selectImage.id)
            if (index > -1) {
              this.selectImages.splice(index, 1)
            }
          } else {
            if (!this._checkMultipleLimit()) {
              // 如果不能选择
              this.$message.error(`最多可以选择${this.multipleLimit}张图片哦`)
              return
            }
            // 如果是选中状态
            // 选中图片前置判断
            let imageStatus = this._interceptSelectImage(imageInfo)
            if (imageStatus) {
              this.selectImages.push(selectImage)
            }
          }
        } else {
          // 单选状态
          if (selectStatus) {
            this.selectImages = []
          } else {
            // 选中图片前置判断
            let imageStatus = this._interceptSelectImage(imageInfo)
            if (imageStatus) {
              this.selectImages = [selectImage]
            }
          }
        }
      }
    },

    // 修改图片名称
    saveImageInfo(valueData) {
      if (!valueData.partName) {
        this.$message.error('请输入图片名称')
        return
      }
      const { partName, description, nameType } = valueData
      const dealPartName = partName.replace(/[\ |\.|\?]/g, '')
      const completeName = `${dealPartName}.${nameType}`
      api
        .editAlbumById({
          id: valueData.id,
          name: completeName,
          description: valueData.description,
          store_id: this.storeId,
        })
        .then(res => {
          if (res.status) {
            this.$message.success('图片信息编辑保存成功')
            this.imageInfo.isShowDescription = false
            this.imageInfo.isShowPictureName = false
            this.imageInfo.name = completeName
            let currentImageIndex = this.imagesList.findIndex(item => item.id === valueData.id)
            let currentImage = this.imagesList[currentImageIndex]
            currentImage.name = completeName
            currentImage.description = description
            this.imagesList.splice(currentImageIndex, 1, currentImage)
          }
        })
    },

    // 插入选中的图片
    submitSelectImages() {
      let selectImages = this.selectImages
      if (this.multiple) {
        // 如果多选
        this.$emit('change', selectImages, this.imagesType)
      } else {
        // 如果单选
        this.$emit('change', selectImages[0], this.imagesType)
      }
      this.closeDialog()
      this._resetSelectImageStatus()
    },
    // 删除选中的图片
    deleteSelectImages() {
      let ids = this.selectImages.map(item => item.id)
      this.delPictureByIds(ids)
    },
    delPictureByIds(ids) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          api
            .delPictureByIds({
              ids,
              store_id: this.storeId,
            })
            .then(res => {
              if (res.status) {
                this.$message.success('删除成功')
                this.currentPage = 1
                this.batchPeration = ''
                this.checkAll = false
                this.getPictureDir(this.currentDir.id)
                this.getImagesList(this.currentDir.id)
                this.selectImages = []
                if (this.imageInfo && ids.includes(this.imageInfo.id)) {
                  this.imageInfo = null
                }
              } else {
                this.$message.error(res.message)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    closeDialog() {
      this.$emit('update:visible', false)
    },

    // 获取当前图片是否被选中
    _getCurrnetImageIsSelect(id) {
      return this.selectImages.some(item => item.id === id)
    },

    // 判断是否可以再选择
    _checkMultipleLimit() {
      let multipleLimit = this.multipleLimit
      let multipleStatus = true
      // 如果存在多选限制 并且 等于了当前选中的数量 则返回false
      if (multipleLimit > 0 && this.selectImages.length === multipleLimit) {
        multipleStatus = false
      }
      return multipleStatus
    },

    _interceptSelectImage(imageInfo) {
      let status = true
      let size = imageInfo.size
      const sizeLimit = Number(this.sizeLimit) * 1024
      if (sizeLimit && size > sizeLimit) {
        status = false
        this.$message.error(`请选择${this.sizeLimit}KB大小以下的图片`)
      }
      return status
    },

    // 重置图片的选中状态
    _resetSelectImageStatus() {
      this.selectImages = []
    },
    // 图片目录点击事件
    clickPictureDir(v, node) {
      this.currentOperatingNode = node
      this.currentDirData = v // 获取当前点击目录的节点信息
      this.currentDir.id = v.id
      this.currentDir.name = v.name
      this.currentDir.pid = v.pid
      this.currentDir.level = v.level
      this.currentDir.store_id = v.store_id
      this.checkAll = false
      this.currentPage = 1
      this.getImagesList(v.id)
    },
    // 图片目录点击事件
    clickCommonPictureDir(v) {
      this.currentCommonId = v.id
      this.checkAll = false
      this.currentPage = 1
      this.getCommonImagesList(v.id)
    },
    // 处理图片目录更新 展示当前节点目录
    getDefaultExpandedkeys(parent) {
      const key = parent.key
      if (!key) {
        this.defaultExpandedkeys = [0]
      } else {
        this.defaultExpandedkeys = [0, key]
      }
    },
    // 图片批量移动到指定目录
    moveImagesToTree(v, nodeData) {
      this.getDefaultExpandedkeys(nodeData.parent)
      const ids = this.selectImages.map(item => item.id)
      const { id } = v

      if (v.store_id !== this.currentDir.store_id) {
        this.$message.error('只能移动到同品牌的目录下！')
        return
      }

      const data = {
        ids,
        category_id: id,
        store_id: this.storeId,
      }
      api.moveAlbumToCategory(data).then(res => {
        this.moveTreevisible = false
        this.selectImages = []
        this.batchPeration = ''
        this.checkAll = false
        this.imageInfo = null
        this.$message.success('移动成功')
        this.getPictureDir(id)
        this.getImagesList(id)
      })
    },
    // 通过关键字 搜索图片
    searchImages(type) {
      this.currentPage = 1
      if (type === 1) {
        this.getImagesList(this.currentDir.id)
      } else {
        this.getCommonImagesList(this.currentCommonId)
      }
    },
    // 清空关键字 搜索图片
    emptySearchResults(type) {
      this.imageName = ''
      this.currentPage = 1
      if (type === 1) {
        this.getImagesList(this.currentDir.id)
      } else {
        this.getCommonImagesList(this.currentCommonId)
      }
    },
    // input输入事件 触发函数
    searchImagesResult(type) {
      //  type 1 我的图库 2 公共图库
      debounce(() => {
        if (type === 1) {
          this.getImagesList(this.currentDir.id)
        } else {
          this.getCommonImagesList(this.currentCommonId)
        }
      }, 500)()
    },
    // 添加分组弹框-保存事件
    saveCategoryAdd(name) {
      const { key } = this.currentOperatingNode
      if (name.length) {
        api
          .addAlbumCategory({
            pid: parseInt(key),
            name,
            store_id: this.storeId,
          })
          .then(res => {
            if (res) {
              if (res.status) {
                this.$message.success('新增目录成功')
                this.getDefaultExpandedkeys(this.currentOperatingNode)
                this.getPictureDir(this.currentDir.id)
              } else {
                this.$message.warning(res.message)
              }
            } else {
              this.$message.warning('系统异常')
            }
          })
      } else {
        this.$message({
          message: '请输入分组名称!',
          type: 'warning',
        })
      }
    },
    // 删除当前分组
    delCategory(operationType) {
      const { key, parent } = this.currentOperatingNode
      const data = {
        type: operationType,
        id: key,
        store_id: this.storeId,
      }
      api.delAlbumCategoryId(data).then(res => {
        if (res) {
          if (res.status) {
            this.$message.success(res.message)
            if (operationType === 1) {
              this.$message.success('目录删除成功')
            } else {
              this.$message.success('目录及图片删除成功')
            }
            this.$refs.deltreePop.closeDialog()
            this.currentPage = 1
            this.getDefaultExpandedkeys(parent)
            if (this.currentDir.id === key) {
              this.getPictureDir(0)
              this.getImagesList(0)
            } else {
              this.getPictureDir(this.currentDir.id)
              this.getImagesList(this.currentDir.id)
            }
          } else {
            this.$message.error(res.message)
          }
        } else {
          this.$message.error('系统异常，请稍后重试。')
        }
      })
    },
    // 修改分组弹框 - 保存事件
    saveCategoryEdit(name) {
      const { data } = this.currentOperatingNode
      if (name.length) {
        api
          .editAlbumCategoryById({
            id: data.id,
            name,
            store_id: this.storeId,
          })
          .then(res => {
            if (res.status) {
              this.$message.success('目录名称修改成功')
              this.getDefaultExpandedkeys(this.currentOperatingNode)
              this.getPictureDir(this.currentDir.id)
            } else {
              this.$message({
                message: res.message,
                type: 'error',
              })
            }
          })
      } else {
        this.$message({
          message: '请输入分组名称!',
          type: 'warning',
        })
      }
    },
    // **********************上传事件群*****************
    /**
     * 上传前验证
     * @param file
     * @returns {boolean}
     */
    beforeAvatarUpload(file) {
      this.uploadedPicturesNumber = 0
      this.uploadParam.category_id = this.currentDir.id
      this.uploadParam.store_id = this.currentDir.store_id
      try {
        const host = window.location.host || ''
        let imageUploadSizeLimit = 2
        // 副作用: 放开部分品牌上传图片大小限制
        // ps: 这将导致qmai-ui的不纯粹，非我本意，奈何这是最高效的方式了
        const brand = JSON.parse(localStorage.getItem('admin.brand')) || {}
        // “永和”客户
        if (
          brand.id == 203683 ||
          host.includes('console-gray.') ||
          host.includes('.qmai.co') ||
          host.includes('.qimai.shop') ||
          host.includes('.zmcms.cn')
        ) {
          imageUploadSizeLimit = 10
        }
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif'
        const isLtMB = file.size / 1024 / 1024 < imageUploadSizeLimit
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/GIF 格式!')
        }
        if (!isLtMB) {
          this.$message.error(`上传图片大小不能超过 ${imageUploadSizeLimit}MB!`)
        }
        if (isJPG && isLtMB) {
          const timestamp = Date.now()
          this.loadingUpload = true
          this.imagesList.unshift({
            id: this.imagesList.length + 1,
            name: file.name,
            size: file.size,
            description: '',
            created_at: timestamp,
            updated_at: timestamp,
            uploadState: 'upload',
          })
        }
        return isJPG && isLtMB
      } catch (e) {
        return false
      }
    },
    /**
     * 上传成功
     * @param res
     * @param file
     */
    onSuccess(res, file) {
      try {
        if (res.status) {
          for (const v of this.imagesList) {
            if (v.uploadState === 'upload' && v.name === res.data.name) {
              this.uploadedPicturesNumber++
              v.uploadState = 'success'
              v.id = res.data.id
              v.domain = res.data.cloudDomain
              v.path = res.data.image_path
              break
            }
          }
          this.$message.success('上传图片成功')
          this.getPictureDir(this.currentDir.id)
          this.getImagesList(this.currentDir.id)
        } else {
          // 上传错误，清除
          this.$message.error(res.message)
          this.imagesList.forEach(v => {
            if (v.uploadState === 'upload') {
              if (v.name === file.name && v.size === file.size) {
                v.uploadState = 'error'
                v.domain = ''
                v.path = ''
              }
            }
          })
        }
        this.loadingUpload = false
      } catch (e) {
        this.loadingUpload = false
      }
    },
    /**
     * 取消上传
     */
    abort() {
      try {
        this.imagesList.forEach((v, i) => {
          if (v.uploadState === 'upload') {
            v.uploadState = 'error'
            this.imagesList.splice(i, 1)
          }
        })
      } catch (e) {}
      this.loadingUpload = false
    },
    /**
     * 上传失败
     * @param res
     * @param file
     */
    onError() {
      this.loadingUpload = false
      this.$message.error('上传失败！')
    },
    /**
     * 删除上传失败的图片
     * @param i
     */
    delUploadError(i) {
      this.imagesList.splice(i, 1)
    },
    handleCommand(command) {
      const { node, type } = command
      const { data } = node
      this.currentOperatingNode = node
      if (type === 'delete') {
        this.$refs.deltreePop.openDialog()
      } else if (type === 'add') {
        // 新增
        this.$prompt('', '新建目录', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入目录名称',
        })
          .then(({ value }) => {
            const name = stripscript(value)
            this.saveCategoryAdd(name)
          })
          .catch(() => {})
      } else {
        // 重命名
        this.$prompt('', '重命名', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputErrorMessage: '请输入目录名称',
          inputValue: data.name,
        })
          .then(({ value }) => {
            const name = stripscript(value)
            this.saveCategoryEdit(name)
          })
          .catch(() => {})
      }
    },
    // 通过src下载图片
    downloadPic(item) {
      this.downloadIamge(`${item.domain}/${item.path}`, item.name)
    },
    downloadIamge(imgsrc, name) {
      // 下载图片地址和图片名
      const image = new Image()
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous')
      image.onload = function () {
        const canvas = document.createElement('canvas')
        canvas.width = image.width
        canvas.height = image.height
        const context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        const url = canvas.toDataURL('image/jpg') // 得到图片的base64编码数据
        const a = document.createElement('a') // 生成一个a元素
        const event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
    },
    // 查看大图
    magnifyThePicture(item) {
      this.dialogImg = `${item.domain}/${item.path}`
      this.dialogImgVisible = true
    },
    // 删除图片
    deletePicture(item) {
      const ids = [item.id]
      this.delPictureByIds(ids)
    },
    // 取消批量操作
    cancelBatchOperations() {
      this.batchPeration = ''
      this.checkAll = false
      this.selectImages = []
    },
    changeSelectVideo(selectVideoData, imagesType) {
      this.$emit('change', selectVideoData, imagesType)
      this.closeDialog()
    },
    // 取消上传默认选中
    deselectUpload() {
      this.imagesList.forEach(item => {
        item.latestUpload = false
      })
    },
    // 剪切图片
    shearPictures(item) {
      const { name } = item
      const fileType = name && name.split('.')[1]
      this.imageClippingVisible = true
      this.imageClippingInfo = {
        name: item.name,
        src: `${item.domain}/${item.path}`,
        fileType,
      }
    },
    // 图片裁剪成功
    imageCroppingSuccess() {
      this.getPictureDir(this.currentDir.id)
      this.getImagesList(this.currentDir.id)
    },
  },
}
</script>
